import script from "./Scene.vue?vue&type=script&setup=true&lang=js"
export * from "./Scene.vue?vue&type=script&setup=true&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=7304b78a&lang=css"

const __exports__ = script;

export default __exports__